import { SxProps, Theme } from '@mui/material';

export const modalBoxSx: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '15px',
  outline: 'none',
};

export const closeButtonWrapperSx: SxProps<Theme> = {
  position: 'absolute',
  top: 16,
  right: 16,
  zIndex: 1,
};

export const gridContainerSx: SxProps<Theme> = {
  textAlign: 'center',
  padding: '16px',
};

export const iconBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '64px',
  height: '64px',
  margin: '22px auto 6px',
};

export const titleSx: SxProps<Theme> = {
  fontFamily: 'Montserrat',
  fontSize: '20px',
  fontWeight: 600,
  lineHeight: '24.38px',
  textAlign: 'center',
  margin: 0,
};

export const messageSx: SxProps<Theme> = {
  fontFamily: 'Nunito',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '21.82px',
  textAlign: 'center',
  color: '#232323',
  margin: 0,
};

export const actionsBoxSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px',
  gap: '16px',
};

export const refundButtonSx: SxProps<Theme> = {
  width: '100%',
  height: '46px',
  padding: '12px 24px',
  borderRadius: '12px',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '22px',
  background: '#F3F3F3',
  border: '1px solid #F3F3F3',
  color: '#232323',
  transition: 'ease-in 0.5s all',
  '&:hover': {
    background: '#E8E8E8',
    borderColor: '#D0D0D0',
  },
};

export const advanceButtonSx: SxProps<Theme> = {
  width: '100%',
  height: '46px',
  padding: '12px 24px',
  borderRadius: '12px',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '22px',
  background: '#505050',
  color: '#FFFFFF',
  transition: 'ease-in 0.5s all',
  '&:hover': {
    background: '#3A3A3A',
  },
};
